import { Alert, Box, CircularProgress } from '@mui/material';
import SftpConnectionImportDetail from './SftpConnectionImports/components/SftpConnectionImportDetail';
import SftpConnectionImportsTable from './SftpConnectionImports/components/SftpConnectionImportsTable';
import { useSftpConnectionImportDetail } from './SftpConnectionImports/hooks/useSftpConnectionImportDetail';

const SftpConnectionImportsContent = ({ organizationId, connection }) => {
  const {
    selectedImport,
    detailLoading,
    downloadLoading,
    loadImportDetail,
    downloadSourceFile,
  } = useSftpConnectionImportDetail({
    organizationId,
    connectionId: connection.id,
  });

  return (
    <Box>
      {!connection.notification_email && (
        <Alert severity='info' sx={{ mb: 2 }}>
          No notification email is configured for this SFTP connection.
        </Alert>
      )}

      <SftpConnectionImportsTable
        organizationId={organizationId}
        connectionId={connection.id}
        onRowClick={detailLoading ? undefined : loadImportDetail}
      />

      <SftpConnectionImportDetail
        organizationId={organizationId}
        connectionId={connection.id}
        selectedImport={selectedImport}
        detailLoading={detailLoading}
        downloadLoading={downloadLoading}
        onDownloadSourceFile={downloadSourceFile}
      />
    </Box>
  );
};

const SftpConnectionImportsSection = ({ organizationId, connection }) => {
  if (!connection?.id) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <SftpConnectionImportsContent
      organizationId={organizationId}
      connection={connection}
    />
  );
};

export default SftpConnectionImportsSection;
